var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f420cb43-bc8c-47fe-b312-82f94f572d47",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-ea34b2d0-a0de-4c62-9e2d-e3e68c223d01 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-ea34b2d0-a0de-4c62-9e2d-e3e68c223d01",
    d: "M15.3,20.69l-3.1.17,2.69-2.69c.29-.29.29-.77,0-1.06s-.77-.29-1.06,0l-2.69,2.69.17-3.1c.03-.55-.39-1.02-.94-1.05-.56-.04-1.02.39-1.05.94l-.3,5.34c-.02.28.09.56.29.76.19.19.44.29.71.29.02,0,.04,0,.06,0l5.34-.3c.55-.03.97-.5.94-1.05-.03-.55-.49-.98-1.05-.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-ea34b2d0-a0de-4c62-9e2d-e3e68c223d01",
    d: "M22.7,9.3c-.2-.2-.48-.31-.76-.29l-5.35.3c-.55.03-.97.5-.94,1.05.03.55.5.96,1.05.94l3.11-.17-2.7,2.69c-.29.29-.29.77,0,1.06.15.15.34.22.53.22s.38-.07.53-.22l2.7-2.7-.17,3.11c-.03.55.39,1.02.94,1.05.02,0,.04,0,.06,0,.53,0,.97-.41,1-.94l.3-5.35c.02-.28-.09-.56-.29-.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.f96db6d9f7745aca6ad7c6e42760932f.svg";
export { ForwardRef as ReactComponent };